module.exports = __webpack_public_path__ + "img/empty-thumbnail2.e6682468.png";